import {
  VideoStyles,
  Video as WorkingWithUsVideo,
} from '@exploration/shared-components';
import { desktop, tablet } from '@thrivent/midwest-shared';
import { MDSText } from '@thrivent/midwest-web';
import styled, { css } from 'styled-components';

const { Image } = VideoStyles;

const contentRootStyle = css`
  flex: 1 1 50%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const WorkingWithUsSectionStyles = {
  Container: styled.div<{
    forceMobileBreakpoint?: boolean;
  }>`
    ${({ forceMobileBreakpoint }) => `
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 4rem;

      ${
        !forceMobileBreakpoint &&
        `
        ${tablet} {
          padding-top: 0.25rem;
        }

        ${desktop} {
          flex-direction: row;
        }
      `
      }
    `}
  `,
  Content: styled.div`
    ${contentRootStyle}
  `,
  ContentText: styled(MDSText.BodyRegDefault)`
    ${contentRootStyle}

    ${({ forceMobileBreakpoint }) =>
      !forceMobileBreakpoint &&
      `
      ${desktop} {
        max-width: 27rem;
      }
    `}
  `,
  VideoHolder: styled.div`
    aspect-ratio: 16 / 9;
    width: 100%;
    position: relative;
    overflow: hidden;
  `,

  Video: styled(WorkingWithUsVideo)`
    height: 100%;
    z-index: 1;

    ${Image} {
      width: auto;
      height: auto;
      ${tablet} {
        width: revert-layer;
        height: revert-layer;
      }
    }
  `,
};
